import { ScanEye } from "lucide-react";

/** Icône « Aperçu » (drawer / consultation), distincte de Eye (visibilité des champs). */
export const ACTION_VIEW_ICON = ScanEye;
